import PropTypes from 'prop-types';
import * as analytics from 'Utils/analytics';
const { EVENTS } = analytics;
const CTA_URLS = {
  SHOWS: process.env.REACT_APP_LIBRARY_CTA_SHOWS_URL,
  FILMS: process.env.REACT_APP_LIBRARY_CTA_FILMS_URL,
  EVENTS: process.env.REACT_APP_LIBRARY_CTA_EVENTS_URL,
  CLIPS: process.env.REACT_APP_LIBRARY_CTA_CLIPS_URL,
  STORIES: process.env.REACT_APP_LIBRARY_CTA_STORIES_URL,
};

const EmptyLibrary = ({
  cta,
  type,
  typeTranslation,
  youAddToYourLibrary,
  youHaventAddedAny,
}) => {
  const handleClick = () => {
    analytics.event({
      action: EVENTS.selectLibraryDiscover,
      label: type.toLowerCase(),
    });
  };

  return (
    <div className="empty-library">
      <div className="empty-library-msg">
        <h1>{youHaventAddedAny.formatUimTranslation(typeTranslation)}</h1>
        <p>{youAddToYourLibrary.formatUimTranslation(typeTranslation)}</p>
        <a
          className="button btn--short"
          href={CTA_URLS[type]}
          onClick={handleClick}
        >
          {cta.formatUimTranslation(typeTranslation)}
        </a>
      </div>
    </div>
  );
};

EmptyLibrary.propTypes = {
  cta: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  typeTranslation: PropTypes.string.isRequired,
  youAddToYourLibrary: PropTypes.string.isRequired,
  youHaventAddedAny: PropTypes.string.isRequired,
};

EmptyLibrary.defaultProps = {};

export default EmptyLibrary;
